export default __webpack_public_path__ + "static/media/liningCircle.d0f114a5.svg";